const ERROR_MESSAGES = {
    400: 'Bad Request',
    401: 'Session expired. Please sign in again.',
    403: 'You don\'t have permission to perform this action.',
    404: 'The requested resource was not found.',
    429: 'Too many requests. Please slow down and try again.',
    500: 'Internal server error. Please try again later.',
    502: 'Bad gateway. Please try again.',
    503: 'Service temporarily unavailable.',
    504: 'Gateway timeout. Please try again.',
    NETWORK_ERROR: 'Network error. Check your connection.',
    TIMEOUT: 'Request timed out. Please try again.'
}

const ACTION_MAP = {
    401: 'signin',
    403: 'home',
    404: 'home',
    429: 'reload',
    500: 'reload',
    502: 'reload',
    503: 'home',
    504: 'reload',
    NETWORK_ERROR: 'reload',
    TIMEOUT: 'reload',
    default: 'home'
}

const extractStatusCode = (error) => {
    if (error?.response?.status) return Number(error.response.status)
    if (error?.response?.data?.status) return Number(error.response.data.status)
    if (error?.status) return Number(error.status)
    if (error?.code) return error.code
    return null
}

const extractErrorMessage = (error) => {
    const data = error?.response?.data
    if (!data) return error?.message || null
    if (typeof data === 'string') return data
    return data.message || data.error_description || data.detail || data.title || data.description || data.error || null
}

export const notifyError = (error) => {
    let statusCode = extractStatusCode(error)
    let message = extractErrorMessage(error) || error?.message || 'Something went wrong'

    if (!statusCode && error?.request) {
        statusCode = 'NETWORK_ERROR'
        message = ERROR_MESSAGES.NETWORK_ERROR
    } else if (statusCode === 'ECONNABORTED' || message?.toLowerCase().includes('timeout')) {
        statusCode = 'TIMEOUT'
        message = ERROR_MESSAGES.TIMEOUT
    } else if (!statusCode) {
        const msgLower = message.toLowerCase()
        if (msgLower.includes('network') || msgLower.includes('connection')) {
            statusCode = 'NETWORK_ERROR'
            message = ERROR_MESSAGES.NETWORK_ERROR
        }
    }

    if (!statusCode || statusCode === 500) {
        const msgLower = message.toLowerCase()
        if (msgLower.includes('429') || msgLower.includes('rate limit') || msgLower.includes('too many')) {
            statusCode = 429
            message = message || ERROR_MESSAGES[429]
        } else if (msgLower.includes('401') || msgLower.includes('unauthorized') || msgLower.includes('auth')) {
            statusCode = 401
            message = message || ERROR_MESSAGES[401]
        } else if (msgLower.includes('403') || msgLower.includes('forbidden')) {
            statusCode = 403
            message = message || ERROR_MESSAGES[403]
        } else if (msgLower.includes('404') || msgLower.includes('not found')) {
            statusCode = 404
            message = message || ERROR_MESSAGES[404]
        }
    }

    if (!statusCode || statusCode === 500) {
        statusCode = 'ERROR'
    }

    const actionType = ACTION_MAP[statusCode] || ACTION_MAP.default

    window.dispatchEvent(new CustomEvent('critical-http-error', {
        detail: { statusCode, timestamp: Date.now(), rawError: error, actionType, message }
    }))
}

export const subscribeToCriticalErrors = (callback) => {
    const handler = (e) => callback(e.detail)
    window.addEventListener('critical-http-error', handler)
    return () => window.removeEventListener('critical-http-error', handler)
}
